import { useInView } from 'react-intersection-observer';
import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const LazyItem = ({ 
  children, 
  threshold = 0.1, 
  triggerOnce = true, 
  delay = 0,
  index = 0,
  ...boxProps 
}) => {
  const { ref, inView } = useInView({
    threshold,
    triggerOnce,
  });

  const variants = {
    hidden: { 
      opacity: 0, 
      y: 30,
      scale: 0.95
    },
    visible: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: { 
        duration: 0.6, 
        ease: "easeOut", 
        delay: delay + (index * 0.1) // Staggered animation
      }
    }
  };

  return (
    <Box
      ref={ref}
      as={motion.div}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      {...boxProps}
    >
      {children}
    </Box>
  );
};

export default LazyItem;
